import React from 'react';
import { Card, Form } from 'react-bootstrap';
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/Footer';
import { useTheme } from '../contexts/ThemeContext';

const PreferencesPage = () => {
  const { theme, themePreference, changeTheme } = useTheme();

  const handleThemeChange = (e) => {
    changeTheme(e.target.value);
  };

  return (
    <>
      <Header />
      <div className="container mt-5 mb-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <Card className="shadow-sm">
              <Card.Header className="bg-primary text-white">
                <h4 className="mb-0">
                  <i className="fas fa-cog me-2"></i>
                  Mes préférences
                </h4>
              </Card.Header>
              <Card.Body className="p-4">
                <h5 className="mb-3 text-primary">Apparence</h5>

                <Form.Group className="mb-4">
                  <Form.Label className="fw-bold">Thème</Form.Label>
                  <div className="mt-2">
                    <Form.Check
                      type="radio"
                      id="theme-auto"
                      name="theme"
                      label={
                        <div>
                          <i className="fas fa-magic me-2"></i>
                          Automatique
                          <small className="text-muted d-block ms-4">
                            Utilise les préférences de votre système d'exploitation
                          </small>
                        </div>
                      }
                      value="auto"
                      checked={themePreference === 'auto'}
                      onChange={handleThemeChange}
                      className="mb-3"
                    />

                    <Form.Check
                      type="radio"
                      id="theme-light"
                      name="theme"
                      label={
                        <div>
                          <i className="fas fa-sun me-2"></i>
                          Mode clair
                          <small className="text-muted d-block ms-4">
                            Interface lumineuse
                          </small>
                        </div>
                      }
                      value="light"
                      checked={themePreference === 'light'}
                      onChange={handleThemeChange}
                      className="mb-3"
                    />

                    <Form.Check
                      type="radio"
                      id="theme-dark"
                      name="theme"
                      label={
                        <div>
                          <i className="fas fa-moon me-2"></i>
                          Mode sombre
                          <small className="text-muted d-block ms-4">
                            Interface sombre pour réduire la fatigue oculaire
                          </small>
                        </div>
                      }
                      value="dark"
                      checked={themePreference === 'dark'}
                      onChange={handleThemeChange}
                      className="mb-3"
                    />
                  </div>
                </Form.Group>

                <div className="p-3 bg-light rounded">
                  <small className="text-muted">
                    <i className="fas fa-info-circle me-2"></i>
                    Thème actif : <strong>{theme === 'dark' ? 'Sombre' : 'Clair'}</strong>
                    {themePreference === 'auto' && ' (détecté automatiquement)'}
                  </small>
                </div>

                <hr className="my-4" />

                <div className="text-muted">
                  <small>
                    <i className="fas fa-wrench me-2"></i>
                    D'autres options de personnalisation seront ajoutées prochainement
                  </small>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PreferencesPage;
